import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslation from './en/translation.json'
import jaTranslation from './ja/translation.json'
import { LanguageEnum } from '../until'

i18next.use(initReactI18next).init({
  lng: LanguageEnum.JAPANESE,
  fallbackLng: LanguageEnum.JAPANESE,
  interpolation: {
    escapeValue: false,
  },
  debug: false,
  resources: {
    en: {
      translation: enTranslation,
    },
    ja: {
      translation: jaTranslation,
    },
  },
})
